import axiosApi from "shared/api/axiosApi";
import { checkCurrentLanguage } from "shared/lib/checkCurrentLanguage";
import { GetPromocodesParams, GetPromocodesRes } from "./types";

export const promocodesAPI = {
  getPromocodesValidate: async (
    params: GetPromocodesParams
  ): Promise<GetPromocodesRes> => {
    const response = await axiosApi.get<GetPromocodesRes>("/promoCodes/validate", {
      params,
      headers: {
        "Accept-Language": checkCurrentLanguage(),
      },
    });
    return response.data;
  }
}